document.addEventListener('click', function (e) {

  const btn = e.target.closest('button[name="add"], .add-to-cart-button');
  if (!btn) return;

  const form = btn.closest('form[action*="/cart/add"]');
  if (!form) return;

  const productCard = form.closest('product-card');

  const productLink =
    productCard?.querySelector('a.product-card__link')?.href ||
    productCard?.querySelector('a[href*="/products/"]')?.href;

  if (!productLink) return;

  // stop theme add-to-cart logic
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  window.location.href = productLink;

}, true);